/* eslint-disable no-new */
export class Tabs {
    constructor({ source, event }) {
        this.source = source;
        this.event = event;
        this.swappers = Array.from(source.querySelectorAll('.js-tab-swap'));
        this.tabs = Array.from(source.querySelectorAll('.js-tab'));
        this.addListeners();
    }

    addListeners() {
        this.swappers.forEach((swapper) => {
            swapper.addEventListener('click', () => this.swapTab(swapper));
        });
    }

    dispatchEvent() {
        window.dispatchEvent(new Event('resize'));
        if (this.event) {
            document.body.dispatchEvent(new CustomEvent(this.event, {}));
        }
    }

    swapTab(swapper) {
        this.deactivateAll();
        const targets = Array.from(
            this.source.querySelectorAll(`[data-tab-name=${swapper.dataset.tab}]`)
        );
        targets.forEach((target) => target.classList.remove('hidden'));
        swapper.classList.add('toggled');
        swapper.querySelector('button').ariaSelected = 'true';

        this.dispatchEvent();
    }

    deactivateAll() {
        this.tabs.forEach((tab) => tab.classList.add('hidden'));
        this.swappers.forEach((swapper) => {
            swapper.classList.remove('toggled');
            swapper.querySelector('button').ariaSelected = 'false';
        });
    }
}

export default (() => {
    const tabs = Array.from(document.querySelectorAll('.js-tabs'));
    tabs.forEach((el) => {
        new Tabs({
            source: el,
            event: el.dataset.event
        });
    });
})();
